// Admin-related test IDs
export const ADMIN = {
	passwordInput: 'admin-password-input',
	loginButton: 'admin-login-button',
	dateInput: 'admin-date-input',
	reasonInput: 'admin-reason-input',
	addButton: 'admin-add-button',
	logoutButton: 'admin-logout-button',
	dateRow: 'admin-date-row',
	removeButton: 'admin-remove-button',
	testimonialNameInput: 'admin-testimonial-name-input',
	testimonialQuoteInput: 'admin-testimonial-quote-input',
	testimonialRatingSelect: 'admin-testimonial-rating-select',
	testimonialAddButton: 'admin-testimonial-add-button',
	testimonialRow: 'admin-testimonial-row',
	testimonialRemoveButton: 'admin-testimonial-remove-button',
};
